<template>
  <page>
    <!-- <template slot="header">
      <div class="container-fluid" >
        <div class="row">
          <div class="col-sm-6">
            <h3 class="m-0 text-dark">
              Ordens de Serviço
            </h3>
          </div>
          <div class="col-sm-6">
            <b-breadcrumb class="float-sm-right" :items="breadcrumbItems"></b-breadcrumb>
          </div>
        </div>
      </div>
    </template> -->

    <template slot='content'>
      <!-- <indicadores-resumo></indicadores-resumo> -->

      <!-- <Hr /> -->

      <os-list></os-list>
      <reloadPage></reloadPage>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page'
import OsList from '@/components/OsList'
// import IndicadoresResumo from '@/components/IndicadoresResumo'
import reloadPage from '../common/reloadPage.vue'

export default {
  components: {
    Page,
    OsList,
    reloadPage
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  created () {
    const dsColaborador = this.$store.getters['filial/filial']
    const host = window.location.host;
    let filial = JSON.parse(localStorage.filial);

    if (filial.fornecExt == 'S') {
        // const newHost = window.location.host + '/osExterna'
        window.location.pathname = '/osExterna'// window.location.host = newHost
    }
  },

  data() {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: 'Ordens para atendimento',
          active: true
        }
      ],
      timer: ''
    }
  },
  methods: {
    reloadPage() {
      let filial = JSON.parse(localStorage.filial);

      if (filial.fornecExt == 'S') {
        return false
      }

      const host = window.location.pathname;

      this.timer = setTimeout(() => {
        if (host == "/" || host == "/osPreventiva") {
          this.$store.dispatch("os/fetchFromApi", {});
        } else if (host == '/osExterna') {
          this.$store.dispatch('os/fetchFromApiExterna')
        }
        this.reloadPage();
      }, 1000 * 5);
      console.log(this.timer)

    }
  }
}
</script>
